import * as types from './actionTypes'

function createSlashHistoriesPayload(data, notLoadMore) {
  const payload = { records: data.records, replace: notLoadMore }
  if (notLoadMore) {
    payload.slashInfo = {
      total_amount: data.total_amount,
      available_amount: data.available_amount,
      exchange_rate: data.exchange_rate,
    }
  }
  return payload
}

export function getInflowHistoriesSuccessAction(data, notLoadMore) {
  return {
    type: types.GET_INFLOW_HISTORIES_SUCCESS,
    payload: createSlashHistoriesPayload(data, notLoadMore),
  }
}

export function getOutflowHistoriesSuccessAction(data, notLoadMore) {
  return {
    type: types.GET_OUTFLOW_HISTORIES_SUCCESS,
    payload: createSlashHistoriesPayload(data, notLoadMore),
  }
}
